module.exports = __webpack_public_path__ + "1.5.0-unryo/img/linux.a4e1f238.svg";